<template>
    <div>
        <Form :model="FormInlineRole"
              :rules="RuleValidate"
              ref="RoleValidate"
              :label-width="124"
              style="text-align: left">
            <FormItem label="选择单位"  prop="SelectRole">
               <div class="selectQY">
                   <div>
                       <Select v-model="SelectRole" @on-change="ChangeRole" :disabled="RoleDisabled">
                           <Option v-for="(item,index) in RoleList" :value="item.ThirdID" :key="index">{{ item.S_QYName }}</Option>
                       </Select>
                   </div>
                   <!--<div>-->
                       <!--<Button type="primary" style="margin:0 10px;" @click="AddRole">新增企业</Button>-->
                   <!--</div>-->
               </div>
            </FormItem>
            <div v-if="IsDisabled">
                <FormItem label="证件类型">
                    <Input v-model="FormInlineRole.TypeSpecification" :disabled="IsDisabled" />
                </FormItem>
                <FormItem label="证件号">
                    <Input v-model="FormInlineRole.S_OrganCode" :disabled="IsDisabled" />
                </FormItem>
            </div>
            <div v-else>
                <FormItem label="证件类型">
                    <Select v-model="FormInlineRole.TypeSpecification">
                        <Option v-for="(item,index) in EnterpriseType" :value="item.Type" :key="index">{{item.TypeSpecification}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="证件号">
                    <Input v-model="FormInlineRole.S_OrganCode" />
                </FormItem>
            </div>
        </Form>
    </div>
</template>

<script>
    export default {
        name: "selectRoleCompany",
        data(e){
            return {
                FormInlineRole:{
                    S_QYName: '',
                    TypeSpecification: '',
                    S_OrganCode: '',
                    I_ISRenZheng:'',
                },
                RuleValidate: {
                    SelectRole:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.SelectRole){return callback(); }
                            else{return callback(new Error("户主不能为空"));}
                        } }],
                },
                Roles: [],
                SelectRole: '',
                EnterpriseType:[],
                IsDisabled:true,
                RoleDisabled:false
            }
        },
        computed: {
            RoleList() {
                return this.$store.state.GetSelectRole.CompanyRoles;
            }
        },
        created(){
            if(this.RoleList&&this.RoleList.length<=0){
                this.$store.commit("GetSelectRole",{_I_Type:3});
            }
        },
        mounted(){
            //this.getSelectRole();
        },
        methods:{
            getPassportType(){
                let that=this;
                this.InApi("api/wangting/UserInfo/SelectCertificationType", {IndividualOrEnterprise: 1},"get").then(function (response) {
                    if(!response) return false;
                    let _data=JSON.parse(response);
                    that.EnterpriseType=_data;
                    that.FormInlineRole.TypeSpecification="企业统一社会信用代码";//后期要验证下对不对
                });
            },
            ChangeRole(item){
                this.IsDisabled=true;
                let that=this;
                (that.RoleList).forEach((n)=>{
                    if(n.ThirdID==item){
                        that.FormInlineRole.S_OrganCode=n.S_OrganCode;
                        that.FormInlineRole.I_ISRenZheng=n.I_ISRenZheng;
                        that.FormInlineRole.TypeSpecification=n.TypeSpecification1;
                    }
                });
                that.$emit("currentRoleData", that.SelectRole);
            },
            AddRole(){
                this.getPassportType();
                this.IsDisabled=false;
                this.FormInlineRole.idNo='';
                this.FormInlineRole.name='';
            },
            ValidateRole(){
                let that=this;
                let _res=false;
                that.$refs["RoleValidate"].validate((valid) => {
                    if (valid) {
                        _res=true;
                    }
                });
                return _res;
            }
        }
    }
</script>
<style scoped>
    .selectQY{display: flex;flex-direction: row;}
    .selectQY>div:first-child{flex:5}
    .selectQY>div:last-child{flex:1}
</style>